module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/download_app_bundle-a2b6f6c6e7fb8b99a1afd928ede11d17.png";